import { TriState } from "./Enums";

export class ContactSearchParameters {
    pageNumber: number = 0;
    searchText: string = "";
    id: number = 0;
    regionID: number = 0;
    supplierID: number = 0;
    isDeleted: TriState = TriState.UseDefault;
}